// components/Login.jsx
import React, { useState, useEffect  } from 'react';
import './css/login.css';
import { CiMail } from "react-icons/ci";
import { MdOutlinePassword } from "react-icons/md";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { url } from '../../Config';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, login } = useAuth();



  const from = location.state?.from?.pathname || "/home";

 
  useEffect(() => {
    if (user) {
      navigate(from, { replace: true });
    }
  }, [user, from, navigate]);

  //console.log(from)


  const [form, setForm] = useState({ identifier: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {

    if (loading) return; // prevent spam clicks
    setLoading(true);

    try {
      const response = await fetch(`${url}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        const err = await response.json();
        alert(err.message || "Login failed");
        setLoading(false);
        return;
      }

      const data = await response.json();
      const token = data.token;

      const decoded = JSON.parse(atob(token.split('.')[1]));
      const userData = { ...decoded, token };

      localStorage.setItem('auth', JSON.stringify(userData));

      await login(form.identifier, form.password);

     // navigate(from, { replace: true });

    } catch (err) {
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">

        <h2 className="login-title">Welcome Back</h2>
        <p className="login-subtitle">Sign in to your account</p>

        <div className="input-group">
          <label><CiMail /> Username or Email</label>
          <input
            type="text"
            name="identifier"
            placeholder="Enter your username or email"
            value={form.identifier}
            onChange={handleChange}
          />
        </div>

        <div className="input-group">
          <label><MdOutlinePassword /> Password</label>
          <input
            type="password"
            name="password"
            placeholder="Enter your password"
            value={form.password}
            onChange={handleChange}
          />
        </div>

        {/* Forgot Password */}
        <div className="forget">
          <Link to="/forgot-password">Forgot Password?</Link>
        </div>

        <button 
          className={`login-btn ${loading ? "loading" : ""}`}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>

        <p className="auth-toggle">
          Don't have an account? <Link to="/signup">Sign Up</Link>
        </p>

      </div>
    </div>
  );
};

export default Login;